// components/ui/Tabs.jsx
import React, { useState } from "react";
import "./Tabs.css";

export default function Tabs({
  tabs = [],
  activeKey,
  defaultActiveKey,
  onTabChange,
  tabProps,
}) {
  const [internalActive, setInternalActive] = useState(defaultActiveKey || tabs?.[0]?.key);
  const isControlled = typeof activeKey === "string" && activeKey.length > 0;
  const currentActive = isControlled ? activeKey : internalActive;
  const activeTab = tabs.find((t) => t.key === currentActive) || tabs?.[0] || {};
  const extraProps =
    activeTab.key && tabProps && typeof tabProps === "object" ? tabProps[activeTab.key] : null;
  const mergedProps = { ...(activeTab.props || {}), ...(extraProps || {}) };
  const ActiveComponent = activeTab.Component || null;

  const handleChange = (key) => {
    if (!isControlled) {
      setInternalActive(key);
    }
    if (onTabChange) {
      onTabChange(key);
    }
  };

  return (
    <div>
      <div className="tabs">
        {tabs.map((t) => (
          <button
            key={t.key}
            className={`tab ${t.key === activeTab.key ? "active-tab" : ""}`}
            onClick={() => handleChange(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {/* Render ONLY the active tab to avoid hidden chart issues */}
      <div className="tab-panel">
        {React.isValidElement(activeTab.render)
          ? activeTab.render
          : ActiveComponent
            ? <ActiveComponent {...mergedProps} />
            : typeof activeTab.render === "function"
              ? activeTab.render(mergedProps)
              : null}
      </div>
    </div>
  );
}
